import React, { useState, useEffect, Fragment } from "react";
import MainNavMenu from "../main-nav-menu/MainNavMenu";
import { styled } from "baseui";
import { ToasterContainer } from "baseui/toast";
import { useHistory } from "react-router-dom";

import { connect } from "react-redux";
import { Auth, Hub } from "aws-amplify";
import { fetchUser, fetchOrganizationStat } from "../../redux/user/UserThunk";
import { setUser } from "../../redux/user/UserActions";
import LoadingComponent from "../../components/loading-component/LoadingComponent";
const StyledDiv = styled("div", ({ $theme }) => ({}));

const toastOverrides = {
  ToastBody: {
    style: ({ $theme }) => ({
      width: "900px",
      // outline: `${$theme.colors.negative300} solid`,
      // backgroundColor: $theme.colors.negative300,
    }),
  },
  ToastInnerContainer: {
    style: ({ $theme }) => ({
      width: "900px",
      // outline: `${$theme.colors.negative300} solid`,
      // backgroundColor: $theme.colors.negative300,
    }),
  },
};

function AppLayout(props) {
  const [user, setStateUser] = useState(props.user);
  const [userSignedIn, setUserSignedIn] = useState(false);
  const history = useHistory();

  useEffect(() => {
    getUser().then((userData) => {
      props.onSetUser(userData);
      props.fetchUser(userData);
    });
  }, []);
  useEffect(() => {
   
  }, [props.isAuthenticated, history, userSignedIn]);


  function getUser() {
    return Auth.currentAuthenticatedUser()
      .then((userData) => {
        console.log(userData);
        return userData;
      })
      .catch(() => console.log("Not signed in"));
  }

  useEffect(() => {
    if(props.user){
      setStateUser(props.user);
    }
  }, [props.user]);

  useEffect(() => {
    if (props.primaryOrgId && props.user?.userId) {
      props.fetchOrganizationStat(props.primaryOrgId);
    }
  }, [props.primaryOrgId, props.userId]);






if (!user || user.userId === "") {
    // Return a loading indicator or any other placeholder if user data is not available
    return <LoadingComponent/>;
  }
  return (
    <Fragment>
      <ToasterContainer overrides={toastOverrides} />
      <MainNavMenu />
      <StyledDiv>{props.children}</StyledDiv>
    </Fragment>
  );
}
const mapStateToProps = (state) => {
  return {
    user: state.user, // Replace with your actual Redux state structure
    primaryOrgId: state.user?.primaryOrgId,
    userId: state.user?.userId,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onSetUser: (user) => {
      dispatch(setUser(user));
    },
    fetchUser: (userData) => {
      dispatch(fetchUser(userData?.attributes["custom:user_id"]));
    },
    fetchOrganizationStat: (organizationId) => {
      dispatch(fetchOrganizationStat(organizationId));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);
